import palette from './palette.json';

export const colors = {
  ...palette,
  primary: palette.primaryred,
  secondary: palette.sandwisp,
};

export type ThemeColor = keyof typeof colors;
